
const checkIfStreamModuleHasChat = (comps, index = 0) => Boolean(comps[index]?.chatChannelID) || Boolean(comps[index]?.qaChannelID);

const checkIfStreamModuleIncludesChat = (comps) => {
  const isFirstComponentStreamModule = Boolean(comps[0].type === 'StreamModule');
  if (isFirstComponentStreamModule) {
    const doesStreamModuleContainChat = checkIfStreamModuleHasChat(comps);
    if (!doesStreamModuleContainChat) {
      return false;
    }
  } else {
    const streamModuleIndex = comps.findIndex(comp => comp.type === 'StreamModule');
    if (streamModuleIndex) {
      const doesStreamModuleContainChat = checkIfStreamModuleHasChat(comps, streamModuleIndex);
      if (!doesStreamModuleContainChat) {
        return false;
      }
    }
  }
  return true;
};


export { checkIfStreamModuleIncludesChat };
